/** Every mailbox's records share this SourceId prefix, so questions search all of them. */
export const EMAIL_SOURCE_PREFIX = 'email:';
export function mailboxSourceId(email) {
    return `${EMAIL_SOURCE_PREFIX}${email.trim().toLowerCase()}`;
}
const EMAIL_PATTERN = /^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)+$/;
export function isValidEmail(value) {
    return EMAIL_PATTERN.test(value.trim());
}
export function domainOf(email) {
    return email.trim().toLowerCase().split('@')[1] ?? '';
}
const imap = (host) => ({ imapHost: host, imapPort: 993, imapSecure: true });
/**
 * IMAP settings for common providers, so adding a mailbox is two answers
 * instead of four. Hosts per docs/email.md §4 and the chatbot project's table.
 */
const PROVIDERS = {
    'gmail.com': imap('imap.gmail.com'),
    'googlemail.com': imap('imap.gmail.com'),
    'yandex.ru': imap('imap.yandex.ru'),
    'yandex.com': imap('imap.yandex.com'),
    'ya.ru': imap('imap.yandex.ru'),
    'mail.ru': imap('imap.mail.ru'),
    'bk.ru': imap('imap.mail.ru'),
    'inbox.ru': imap('imap.mail.ru'),
    'list.ru': imap('imap.mail.ru'),
    'outlook.com': imap('outlook.office365.com'),
    'hotmail.com': imap('outlook.office365.com'),
    'live.com': imap('outlook.office365.com'),
    'icloud.com': imap('imap.mail.me.com'),
    'me.com': imap('imap.mail.me.com'),
    'yahoo.com': imap('imap.mail.yahoo.com'),
};
export function detectMailProvider(email) {
    return PROVIDERS[domainOf(email)];
}
/**
 * A custom domain may be Google Workspace, where app passwords stopped working
 * on 1 May 2025 (docs/email.md §4). Worth saying before the user types one.
 */
export function mayNeedOauth(email) {
    const domain = domainOf(email);
    return domain !== '' && PROVIDERS[domain] === undefined;
}
//# sourceMappingURL=mailbox.js.map